import { computed, ref } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fa961fc6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainComponent"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "head"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "searchName"
}, [/*#__PURE__*/_createElementVNode("span", null, "国家/地区")]), /*#__PURE__*/_createElementVNode("div", {
  class: "priceUpdate"
}, [/*#__PURE__*/_createElementVNode("span", null, "基础方案价格")]), /*#__PURE__*/_createElementVNode("div", {
  class: "priceUpdate"
}, [/*#__PURE__*/_createElementVNode("span", null, "折扣价格")])], -1));
const _hoisted_4 = {
  class: "body"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据，等待输入默认价格", -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "price"
};
const _hoisted_8 = {
  class: "currency"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "iconBk"
}, " 免费 ", -1));
const _hoisted_10 = {
  class: "extraInfo"
};
import { queryPriceList } from '@/api/goodsSetting';
import useDetailHooks from '../hooks/useDetailHooks';
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceBlock1',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    prodChnl: {
      type: String,
      default: ''
    },
    prodType: {
      type: String,
      default: ''
    },
    prodPriceCurrency: {
      type: String,
      default: ''
    },
    loading: {
      default: false,
      type: Boolean
    },
    yhConturyPrice: {
      type: Array,
      default: () => []
    }
  },
  setup(__props, {
    expose
  }) {
    const props = __props;
    // import SvgIcon from '@/components/SvgIcon.vue'
    const {
      verifyNumber
    } = useDetailHooks();
    const prodChnlText = computed(() => {
      if (props.prodChnl === 'google') {
        return '*当前本地价格已采取谷歌定价模式';
      } else if (props.prodChnl === 'huawei' || props.prodChnl === 'huawei_foreign' || props.prodChnl === 'harmony') {
        return '*当前本地价格已采取华为定价模式';
      } else if (props.prodChnl === 'apple') {
        return '*请注意，未修改过本地价格的国家和地区，本地价格会随苹果汇率变化而自动变化';
      }
    });
    const searchMode = ref(true); // 开关过滤
    const queryPriceLoading = ref(false); // 加载效果
    const searchName = ref(''); // 绑定过滤搜索
    const showData = ref([]); // 经过筛选展示在下方的数据集
    const originData = ref([]); // 后端查询出来的数据集
    // const emits = defineEmits(['updateList', 'updateInputPrice'])
    const regroupData = dataArr => {
      if (!dataArr || (dataArr === null || dataArr === void 0 ? void 0 : dataArr.length) === 0) return [];
      let newArr = [];
      dataArr.map((item, ind) => {
        item['editMode'] = false;
        item['key'] = Math.random() * 10000 + '-' + ind;
        if (item.prodPrice !== item.originProdPrice) {
          newArr.unshift(item);
        } else {
          newArr.push(item);
        }
      });
      return newArr;
    };
    const queryData = async data => {
      if (!data.prodPrice) {
        originData.value = []; // 不输入默认价格，就查不到列表信息，所以置空
        showData.value = [];
      } else {
        queryPriceLoading.value = true;
        const res = await queryPriceList(data);
        queryPriceLoading.value = false;
        if (res.code === '0') {
          var _res$data;
          originData.value = regroupData((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.productNativePrice);
          searcher();
        } else {
          originData.value = [];
          showData.value = [];
        }
      }
    }; // 查询价格信息
    const init = data => {
      originData.value = regroupData(data === null || data === void 0 ? void 0 : data.productNativePrice);
      searcher();
    }; // 编辑回显数据
    const reset = () => {
      searchName.value = '';
      searchMode.value = false;
      queryPriceLoading.value = false;
      originData.value = [];
      showData.value = [];
    };
    // const askQuery = () => {
    //   emits('updateList')
    // }
    const formatPrice = async (val, i) => {
      const flag = await verifyNumber({
        prodChnl: props.prodChnl,
        prodPrice: val,
        prodPriceCurrency: showData.value[i].prodPriceCurrency,
        regionCode: showData.value[i].regionCode,
        prodType: props.prodType
      });
      if (!flag) {
        showData.value[i].prodPrice = showData.value[i].originProdPrice;
      } else {
        showData.value[i].prodPrice = parseFloat(val).toFixed(2);
      }
    };
    // const confirmChange = (item: goodsPriceComponentItem, i: number) => {
    //   item.editMode = false
    //   // 修改过后的内容要置顶
    //   if (item.prodPrice !== item.originProdPrice) {
    //     showData.value.splice(i, 1)
    //     showData.value.unshift(item)
    //   }
    //   emits('updateInputPrice')
    // }
    const searcher = () => {
      showData.value = originData.value.filter(item => {
        if (searchName.value.trim()) {
          return item.regionName.includes(searchName.value);
        } else {
          return item;
        }
      });
      handleDataTop();
    }; // 数据搜索过滤
    // const cancelData = (item: goodsPriceComponentItem) => {
    //   item.prodPrice = item.originProdPrice
    //   item.editMode = false
    // } // 取消数据修改
    const handleDataTop = () => {
      showData.value.forEach(item => {
        if (item.prodPrice !== item.originProdPrice) {
          showData.value.splice(showData.value.indexOf(item), 1);
          showData.value.unshift(item);
        }
      });
    }; // 修改过的数据置顶
    expose({
      init,
      queryData,
      reset,
      originData
    });
    return (_ctx, _cache) => {
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_input_number = _resolveComponent("a-input-number");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_withDirectives(_createVNode(_component_a_spin, {
        class: "spinBody",
        tip: "加载中..."
      }, null, 512), [[_vShow, queryPriceLoading.value || __props.loading]]), _withDirectives(_createElementVNode("div", null, _hoisted_6, 512), [[_vShow, !__props.yhConturyPrice.length && !queryPriceLoading.value && !__props.loading]]), _withDirectives(_createElementVNode("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.yhConturyPrice, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item"
        }, [_createElementVNode("div", {
          class: _normalizeClass(['country', {
            editLine: item.prodPrice !== item.originProdPrice
          }])
        }, _toDisplayString(item.regionName), 3), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(item.prodPriceCurrency), 1), _withDirectives(_createElementVNode("div", {
          class: "priceNum"
        }, _toDisplayString(item.prodPrice), 513), [[_vShow, !item.editMode]]), _withDirectives(_createVNode(_component_a_input_number, {
          class: "littlePriceInputer",
          size: "small",
          value: item.prodPrice,
          "onUpdate:value": $event => item.prodPrice = $event,
          min: 0,
          controls: false,
          step: 0.01,
          precision: 2,
          "string-mode": "",
          onBlur: $event => formatPrice(item.prodPrice, i)
        }, null, 8, ["value", "onUpdate:value", "step", "onBlur"]), [[_vShow, item.editMode && !props.disabled]]), _hoisted_9])]);
      }), 128))], 512), [[_vShow, !queryPriceLoading.value && __props.yhConturyPrice.length && !__props.loading]])])])]), _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(prodChnlText)), 1)], 64);
    };
  }
});